import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_N_OPEN_ACCOUNT = '/spe-n-open-account';
let SpeNOpenAccountProxy = class SpeNOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getPreAccount(uuid) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/${uuid}`;
        return this.api.get(uri);
    }
    getBusinessPartners(uuid) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/${uuid}/business-partner`;
        return this.api.get(uri);
    }
    createPreAccount(preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account`;
        return this.api.post(uri, preAccount);
    }
    updatePreAccount(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateStatus(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/analysis/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateLastStep(id, step) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/last-step/${id}/step/?step=${step}`;
        return this.api.put(uri, null);
    }
    updateStep(id, currentStep) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/step/`;
        return this.api.put(uri, { id, currentStep });
    }
    updatePersonalData(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/personal-data/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateAddressData(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/address-data/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateComercialAgent(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/comercial-agent-data/${id}`;
        return this.api.put(uri, preAccount);
    }
    updatedContract(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/contract/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateCompanyAddress(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/company-address/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateCompanyData(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/company-data/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateProfessionalType(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/professional-type/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateBusinessPartner(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/business-partner/${id}`;
        return this.api.put(uri, preAccount);
    }
    createBusinessPartner(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/business-partner/${id}`;
        return this.api.post(uri, preAccount);
    }
    updateBusinessPersonalPartnerData(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/business-partner/personal-data/${id}`;
        return this.api.put(uri, preAccount);
    }
    updateBusinessAddressPartnerData(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/business-partner/personal-address/${id}`;
        return this.api.put(uri, preAccount);
    }
    createCompanyAddress(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/new`;
        return this.api.post(uri);
    }
    getCep(zipcode) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/cep/${zipcode}`;
        return this.api.get(uri);
    }
    createTypeAccount(id, accountPaymentType, nextStep) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/type-account/${id}/next-step/${nextStep}`;
        return this.api.put(uri, accountPaymentType);
    }
    accountIsMoreFivek(id) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/account-more-five-thousand/${id}`;
        return this.api.post(uri);
    }
    findTypeDocumentUploaded(id) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/uploaded-type-account/${id}`;
        return this.api.get(uri);
    }
    findByAccountType(idWhiteLAbel) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/account-type/white-label/${idWhiteLAbel}`;
        return this.api.get(uri);
    }
    findByWhiteLabelAndCpf(uuidWhiteLabel, cpf) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/cpf/${cpf}/wlp/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    // Method finds accounts by document to retry onboarding
    findAccountsForRetryOnboarding(data) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/find-account-for-retry-onboarding`;
        return this.api.post(uri, data);
    }
    addUserInterest(userId, interests) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/interest/${userId}`;
        return this.api.put(uri, interests);
    }
    documentAccount(data) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v2/document-account`;
        return this.api.post(uri, data);
    }
    validationCode(data) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/validation-code`;
        return this.api.post(uri, data);
    }
    resendCode(data) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/send-validation-code/resend`;
        return this.api.post(uri, data);
    }
    sendCode(data) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/send-validation-code`;
        return this.api.post(uri, data);
    }
    dataAccount(data) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v2/name-email-phone-account`;
        return this.api.post(uri, data);
    }
    findDocumentsToUpload(id, step) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v2/find-documents-to-upload`;
        return this.api.post(uri, { id, step });
    }
    findDocumentsPartnerToUpload(id, idBusinessPartner, step) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v2/find-documents-to-upload`;
        return this.api.post(uri, { id, idBusinessPartner, step });
    }
    sendContract(id, data) {
        let url = `${SPE_N_OPEN_ACCOUNT}/v1/contract/${id}`;
        return this.api.put(url, data);
    }
    removePartner(id, partnerId) {
        let url = `${SPE_N_OPEN_ACCOUNT}/v1/business-partner/${id}/partner/${partnerId}`;
        return this.api.delete(url);
    }
    getPartners(id) {
        let url = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/${id}/business-partner`;
        return this.api.get(url);
    }
    sendEmailContractPartners(id) {
        let url = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/business-partner/resend-email`;
        const data = {
            _id: id
        };
        return this.api.post(url, data);
    }
    linkValidatoinEmail(validation) {
        let url = `${SPE_N_OPEN_ACCOUNT}/v1/link-validation-email`;
        const data = {
            validation
        };
        return this.api.post(url, data);
    }
    createLiveness(preAccountId, data) {
        const url = `${SPE_N_OPEN_ACCOUNT}/v2/liveness/${preAccountId}`;
        return this.api.post(url, data);
    }
    finalizeLiveness(preAccountId) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v2/liveness/finalize/${preAccountId}`;
        return this.api.post(uri);
    }
};
SpeNOpenAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNOpenAccountProxy);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_N_OPEN_ACCOUNT_UPLOAD = '/spe-n-open-account-upload';
let SpeNOpenAccountUploadProxy = class SpeNOpenAccountUploadProxy {
    constructor(api) {
        this.api = api;
    }
    uploadFile(id, upload) {
        const uri = `${SPE_N_OPEN_ACCOUNT_UPLOAD}/v1/upload/${id}`;
        return this.api.put(uri, upload);
    }
    uploadPartnerFile(id, partnerId, upload) {
        const uri = `${SPE_N_OPEN_ACCOUNT_UPLOAD}/v1/upload/${id}`;
        upload.idBusinessPartner = partnerId;
        upload.id = id;
        return this.api.put(uri, upload);
    }
};
SpeNOpenAccountUploadProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNOpenAccountUploadProxy);

const SPE_VIEW_PRE_ACCOUNT = '/spe-view-pre-account';
let SpeViewPreAccountProxy = class SpeViewPreAccountProxy {
    constructor(api) {
        this.api = api;
    }
    findPreAccount(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/${id}`;
        return this.api.get(uri);
    }
    findContract(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/contract/${id}`;
        return this.api.get(uri);
    }
    findComercialAgent(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/comercial-agent/${id}`;
        return this.api.get(uri);
    }
    findAccountType(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/account-type/${id}`;
        return this.api.get(uri);
    }
    findUploads(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/uploads/${id}`;
        return this.api.get(uri);
    }
    findPersonalData(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/personal-data/${id}`;
        return this.api.get(uri);
    }
    findPersonalAddress(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/address/${id}`;
        return this.api.get(uri);
    }
    findProfessionalType(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/professional-type/${id}`;
        return this.api.get(uri);
    }
    findPartners(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/partners/${id}`;
        return this.api.get(uri);
    }
    findCompanyData(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/company/${id}`;
        return this.api.get(uri);
    }
    findCompanyAddress(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/company-address/${id}`;
        return this.api.get(uri);
    }
    findAccountTypeByWhiteLabel(idWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/account-type/white-label/${idWhiteLabel}`;
        return this.api.get(uri);
    }
    findAccountTypeByWhiteLabelVisible(idWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/account-type/of-wl/${idWhiteLabel}/visible`;
        return this.api.get(uri);
    }
    findStatusById(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/status/${id}`;
        return this.api.get(uri);
    }
    findEmailByIdAndEmailAndWhiteLabel(id, email, idWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/pre-account/verify-email/of-id/${id}/of-email/${email}/of-whitelabel/${idWhiteLabel}`;
        return this.api.get(uri);
    }
    findEmailByCpfAndEmailAndWhiteLabel(cpf, email, idWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/pre-account/verify-email/of-cpf/${cpf}/of-email/${email}/of-whitelabel/${idWhiteLabel}`;
        return this.api.get(uri);
    }
    findEmailByEmailAndWhiteLabel(email, idWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/pre-account/verify-email/of-email/${email}/of-whitelabel/${idWhiteLabel}`;
        return this.api.get(uri);
    }
    findInterests(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/domain/interest/wl/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findAccountMigration(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/migration/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    getSteps(uuidWhiteLabel, accountType) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/onboarding-account-step/white-label/${uuidWhiteLabel}/account-type/${accountType}`;
        return this.api.get(uri);
    }
    getOnboardingAccountStep(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/onboarding-account-step/id-pre-account/${id}`;
        return this.api.get(uri);
    }
    getTermByuuid(uuid) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/contract-terms/${uuid}`;
        return this.api.get(uri);
    }
    getTerm(id) {
        let url = `${SPE_VIEW_PRE_ACCOUNT}/v1/contract-terms/pre-account/${id}`;
        return this.api.get(url);
    }
    getPartners(id) {
        let url = `${SPE_VIEW_PRE_ACCOUNT}​/v1​/pre-account​/status-contract-terms-business-partner​/${id}`;
        return this.api.get(url);
    }
    getPartnersContract(_id) {
        let url = `${SPE_VIEW_PRE_ACCOUNT}/v1/pre-account/status-contract-terms-business-partner/${_id}`;
        return this.api.get(url);
    }
    getStatusPartnersContractSteps(id, idPartner) {
        /* let url = `${SPE_VIEW_PRE_ACCOUNT}​/v1​/pre-account​/status-contract-terms-business-partner​/${id}​/partner​/${idPartner}`; */
        let url = `${SPE_VIEW_PRE_ACCOUNT}/v1/pre-account/status-contract-terms-business-partner/${id}/partner/${idPartner}`;
        return this.api.get(url);
    }
};
SpeViewPreAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewPreAccountProxy);

const SPE_J_OPEN_ACCOUNT_UPLOAD = '/spe-j-open-account-upload';
let SpeJOpenAccountUploadProxy = class SpeJOpenAccountUploadProxy {
    constructor(api) {
        this.api = api;
    }
    uploadFile(id, upload) {
        let ownership = !!upload.ownership ? upload.ownership : '';
        const uri = `${SPE_J_OPEN_ACCOUNT_UPLOAD}/v1/image/upload/${id}?typeDocument=${upload.uploadType}&position=${upload.positionPhoto}&ownership=${ownership}`;
        let nameFile = !!upload.fileName ? upload.fileName : 'imagem.jpeg';
        // preparando objeto para converter para blob
        let image64 = upload.fileBase64;
        let block = image64.photo.split(";");
        let contentType = block[0].split(":")[1];
        let realData = block[1].split(",")[1];
        // convertendo para blob
        const blob = this.b64toBlob(realData, contentType);
        const formData = new FormData();
        const file = new File([blob], nameFile);
        formData.append('file', file);
        return this.api.post(uri, formData);
    }
    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        let byteCharacters = atob(b64Data);
        let byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
};
SpeJOpenAccountUploadProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJOpenAccountUploadProxy);

let UiPxSignupModule = class UiPxSignupModule {
};
UiPxSignupModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeNOpenAccountProxy,
            SpeNOpenAccountUploadProxy,
            SpeJOpenAccountUploadProxy,
            SpeViewPreAccountProxy,
            ConfigService
        ]
    })
], UiPxSignupModule);

var YesOrNot;
(function (YesOrNot) {
    YesOrNot["NOT"] = "NOT";
    YesOrNot["YES"] = "YES";
})(YesOrNot || (YesOrNot = {}));

var Status;
(function (Status) {
    // Status de andamento do flow do usuário
    Status["IN_ONBORDING"] = "IN_ONBORDING";
    Status["WAITING_TERMS_ACCEPTANCE"] = "WAITING_TERMS_ACCEPTANCE";
    Status["AWAIT_EMAIL_CONFIRMATION"] = "AWAIT_EMAIL_CONFIRMATION";
    Status["CANCELLATION_REQUEST"] = "CANCELLATION_REQUEST";
    Status["LIVENESS_INCOMPLETED"] = "LIVENESS_INCOMPLETED";
    Status["LIVENESS_REVALIDATE"] = "LIVENESS_REVALIDATE";
    // Analise de backoffice
    Status["IN_ANALYSIS_COMPLIANCE"] = "IN_ANALYSIS_COMPLIANCE";
    Status["IN_ANALYSIS_COMPLIANCE_MANUAL"] = "IN_ANALYSIS_COMPLIANCE_MANUAL";
    Status["APPROVED_COMPLIANCE"] = "APPROVED_COMPLIANCE";
    Status["IN_ANALYSIS_BACKOFFICE"] = "IN_ANALYSIS_BACKOFFICE";
    Status["IN_ANALYSIS_BACKOFFICE_AUTOMATIC"] = "IN_ANALYSIS_BACKOFFICE_AUTOMATIC";
    Status["APPROVED_BACKOFFICE"] = "APPROVED_BACKOFFICE";
    Status["APPROVED_BACKOFFICE_AUTOMATIC"] = "APPROVED_BACKOFFICE_AUTOMATIC";
    // Fechamento de fluxo
    Status["FINISHED"] = "FINISHED";
    Status["REPROVED"] = "REPROVED";
    Status["PENDENT"] = "PENDENT";
    // Documento / Dados invalidos
    Status["DOCUMENT_PHYSICAL_PERSON_REPROVED"] = "DOCUMENT_PHYSICAL_PERSON_REPROVED";
    Status["DOCUMENT_LEGAL_PERSON_REPROVED"] = "DOCUMENT_LEGAL_PERSON_REPROVED";
    Status["REGISTRATION_DATA_PHYSICAL_PERSON_INVALID"] = "REGISTRATION_DATA_PHYSICAL_PERSON_INVALID";
    Status["REGISTRATION_DATA_LEGAL_PERSON_INVALID"] = "REGISTRATION_DATA_LEGAL_PERSON_INVALID";
    Status["DOCUMENT_AND_REGISTRATION_DATA_PHYSICAL_PERSON_REPROVED"] = "DOCUMENT_AND_REGISTRATION_DATA_PHYSICAL_PERSON_REPROVED";
    Status["DOCUMENT_AND_REGISTRATION_DATA_LEGAL_PERSON_REPROVED"] = "DOCUMENT_AND_REGISTRATION_DATA_LEGAL_PERSON_REPROVED";
    // Analise no parceiro
    Status["IN_ANALYSIS_TOPAZIO"] = "IN_ANALYSIS_TOPAZIO";
    Status["APPROVED_TOPAZIO"] = "APPROVED_TOPAZIO";
    Status["IN_ANALYSIS_ITAU"] = "IN_ANALYSIS_ITAU";
    Status["APPROVED_ITAU"] = "APPROVED_ITAU";
    Status["REPROVED_ITAU"] = "REPROVED_ITAU";
    Status["IN_ANALYSIS_URBANO"] = "IN_ANALYSIS_URBANO";
    Status["APPROVED_URBANO"] = "APPROVED_URBANO";
    Status["REPROVED_URBANO"] = "REPROVED_URBANO";
})(Status || (Status = {}));
var ProcessResultUnicoEnum;
(function (ProcessResultUnicoEnum) {
    ProcessResultUnicoEnum["PROCESS_RESULT_OK"] = "PROCESS_RESULT_OK";
    ProcessResultUnicoEnum["PROCESS_RESULT_WARNING"] = "PROCESS_RESULT_WARNING";
    ProcessResultUnicoEnum["PROCESS_RESULT_ERROR"] = "PROCESS_RESULT_ERROR";
    ProcessResultUnicoEnum["PROCESS_RESULT_UNSPECIFIED"] = "PROCESS_RESULT_UNSPECIFIED";
    ProcessResultUnicoEnum["PROCESS_RESULT_EXPIRED"] = "PROCESS_RESULT_EXPIRED";
})(ProcessResultUnicoEnum || (ProcessResultUnicoEnum = {}));
var ProcessStatusUnicoEnum;
(function (ProcessStatusUnicoEnum) {
    ProcessStatusUnicoEnum["PROCESS_STATE_CREATED"] = "PROCESS_STATE_CREATED";
    ProcessStatusUnicoEnum["PROCESS_STATE_FINISHED"] = "PROCESS_STATE_FINISHED";
    ProcessStatusUnicoEnum["PROCESS_STATE_FAILED"] = "PROCESS_STATE_FAILED";
})(ProcessStatusUnicoEnum || (ProcessStatusUnicoEnum = {}));

var LevelRiskEnum;
(function (LevelRiskEnum) {
    LevelRiskEnum["HIGH"] = "HIGH";
    LevelRiskEnum["MEDIUM"] = "MEDIUM";
    LevelRiskEnum["LOW"] = "LOW";
    LevelRiskEnum["NO_CLASSIFICATION"] = "NO_CLASSIFICATION";
})(LevelRiskEnum || (LevelRiskEnum = {}));

var TypeEnum;
(function (TypeEnum) {
    TypeEnum["MAIN"] = "MAIN";
    TypeEnum["RESIDENTIAL"] = "RESIDENTIAL";
    TypeEnum["COMMERCIAL"] = "COMMERCIAL";
    TypeEnum["MESSAGES"] = "MESSAGES";
})(TypeEnum || (TypeEnum = {}));

var MaritalEnum;
(function (MaritalEnum) {
    MaritalEnum["MARRIED"] = "MARRIED";
    MaritalEnum["DIVORCED"] = "DIVORCED";
    MaritalEnum["SINGLE"] = "SINGLE";
    MaritalEnum["WIDOWED"] = "WIDOWED";
})(MaritalEnum || (MaritalEnum = {}));

var Deleted;
(function (Deleted) {
    Deleted["FALSE"] = "FALSE";
    Deleted["TRUE"] = "TRUE";
})(Deleted || (Deleted = {}));

var TypeAccountEnum;
(function (TypeAccountEnum) {
    TypeAccountEnum["PHYSICAL_PERSON"] = "PHYSICAL_PERSON";
    TypeAccountEnum["LEGAL_PERSON"] = "LEGAL_PERSON";
    TypeAccountEnum["MEI"] = "MEI";
    TypeAccountEnum["LIBERAL_PROFESSIONAL"] = "LIBERAL_PROFESSIONAL";
    TypeAccountEnum["START"] = "START";
    TypeAccountEnum["START_ONBOARDING_UNICO"] = "START_ONBOARDING_UNICO";
    TypeAccountEnum["PHYSICAL_PERSON_IDUNICO"] = "PHYSICAL_PERSON_IDUNICO";
    TypeAccountEnum["MEI_IDUNICO"] = "MEI_IDUNICO";
})(TypeAccountEnum || (TypeAccountEnum = {}));

var PositionPhotoEnum;
(function (PositionPhotoEnum) {
    PositionPhotoEnum["FRONT"] = "FRONT";
    PositionPhotoEnum["VERSE"] = "VERSE";
})(PositionPhotoEnum || (PositionPhotoEnum = {}));

var UploadTypeEnum;
(function (UploadTypeEnum) {
    UploadTypeEnum["CPF"] = "CPF";
    UploadTypeEnum["CNPJ"] = "CNPJ";
    UploadTypeEnum["RESIDENCIAL_CERTIFICATE"] = "RESIDENCIAL_CERTIFICATE";
    UploadTypeEnum["RG"] = "RG";
    UploadTypeEnum["CNH"] = "CNH";
    UploadTypeEnum["SOCIAL_CONTRACT"] = "SOCIAL_CONTRACT";
    UploadTypeEnum["MEI_OPENING_TERMS"] = "MEI_OPENING_TERMS";
    UploadTypeEnum["MINUTES_MEETING"] = "MINUTES_MEETING";
    UploadTypeEnum["PROFESSIONAL_CERTIFICATE"] = "PROFESSIONAL_CERTIFICATE";
    UploadTypeEnum["SELF_PHOTO"] = "SELF_PHOTO";
    UploadTypeEnum["ATTORNEY_LETTER"] = "ATTORNEY_LETTER";
    UploadTypeEnum["RESIDENCIAL_CERTIFICATE_LEGAL_PERSON"] = "RESIDENCIAL_CERTIFICATE_LEGAL_PERSON";
})(UploadTypeEnum || (UploadTypeEnum = {}));

var StatusDefaultEnum;
(function (StatusDefaultEnum) {
    StatusDefaultEnum["INACTIVE"] = "INACTIVE";
    StatusDefaultEnum["ACTIVE"] = "ACTIVE";
})(StatusDefaultEnum || (StatusDefaultEnum = {}));

var TypeFlowEnum;
(function (TypeFlowEnum) {
    TypeFlowEnum["PHYSICAL_PERSON"] = "0";
    TypeFlowEnum["LEGAL_PERSON"] = "1";
    TypeFlowEnum["MEI"] = "2";
    TypeFlowEnum["LIBERAL_PROFESSIONAL"] = "3";
})(TypeFlowEnum || (TypeFlowEnum = {}));

var OwnershipEnum;
(function (OwnershipEnum) {
    OwnershipEnum["OWNERAOFTHECCOUNT"] = "OWNERAOFTHECCOUNT";
    OwnershipEnum["SPOUSE"] = "SPOUSE";
    OwnershipEnum["FATHERORMOTHER"] = "FATHERORMOTHER";
    OwnershipEnum["BROTHERORSISTER"] = "BROTHERORSISTER";
})(OwnershipEnum || (OwnershipEnum = {}));

class ReportBureausDto {
}
var ReportBureausStatusEnum;
(function (ReportBureausStatusEnum) {
    ReportBureausStatusEnum["CONCLUIDO"] = "CONCLUIDO";
    ReportBureausStatusEnum["EM_ANALISE"] = "EM ANALISE";
    ReportBureausStatusEnum["PRE_PROCESSANDO"] = "PRE-PROCESSANDO";
    ReportBureausStatusEnum["PROCESSANDO"] = "PROCESSANDO";
})(ReportBureausStatusEnum || (ReportBureausStatusEnum = {}));
var ReportBureausTypeEnum;
(function (ReportBureausTypeEnum) {
    ReportBureausTypeEnum["IDWALL"] = "IDWALL";
    ReportBureausTypeEnum["SERASA"] = "SERASA";
    ReportBureausTypeEnum["IDUNICO"] = "IDUNICO";
})(ReportBureausTypeEnum || (ReportBureausTypeEnum = {}));
class ReportDetailBase {
    constructor(historyConsult) {
        this.historyConsult = historyConsult;
    }
}
class HystoryConsult {
}

class CreateLivenessBodyDTO {
}
class LivenessOnboardingResponseDTO {
}

class CreateLivenessResponseDTO {
}

export { ConfigService, CreateLivenessBodyDTO, CreateLivenessResponseDTO, Deleted, HystoryConsult, LevelRiskEnum, LivenessOnboardingResponseDTO, MaritalEnum, OwnershipEnum, PositionPhotoEnum, ProcessResultUnicoEnum, ProcessStatusUnicoEnum, ReportBureausDto, ReportBureausStatusEnum, ReportBureausTypeEnum, ReportDetailBase, SpeJOpenAccountUploadProxy, SpeNOpenAccountProxy, SpeNOpenAccountUploadProxy, SpeViewPreAccountProxy, Status, StatusDefaultEnum, TypeAccountEnum, TypeEnum, TypeFlowEnum, UiPxSignupModule, UploadTypeEnum, YesOrNot };
//# sourceMappingURL=wlp-ui-px-signup.js.map
